export interface IAddress {
    _id?: string;
    display_name?: string;
    ref?: string;
    line_1: string;
    line_2?: string;
    line_3?: string;
    line_4?: string;
    code?: string;

    city?: string;
    state?: string;
    zip?: string;

    surcharge?: number;
    surcharge_label?: string;

    phone?: string;
    country?: string;

    default_billing?: boolean;
    default_shipping?: boolean;

    type?: "billing" | "shipping" | "both";

    billing_code?: string;
    shipping_code?: string;

    warehouse?: string;
}

export interface ICompanyRep {
    ref: string;
    email: string;
    name: string;
}

export enum AccessControl {
    /**
     * Every buyer in company has no access to brand
     */
    NoAccess = 0,
    /**
     * Every buyer in company has access to brand as if `company_access_control` brand pref is off
     */
    FullAccess = 10,
}

export interface ICompany {
    _id?: string;
    brand: string;
    retailer_id: string;
    code?: string;

    name: string;
    currency_codes: string[];
    msrp_currency_codes?: string[];
    customer_groups: string[];
    discount?: number;
    surcharge?: number;
    surcharge_label?: string;

    pricing_template?: string;

    warehouse: string;
    allow_bulk?: boolean;
    legal_file?: string;

    addresses: IAddress[];
    reps: ICompanyRep[];
    user_connections: IUserConnection[];
    __sortable_name?: string;
    created_on?: string;

    // default FDM fields
    phone?: string;
    website?: string;
    merchant_id?: number;
    __allow_bypass_inventory?: boolean;

    access_control?: AccessControl;
}

export interface IUserConnection {
    _id?: string;
    name: string;
    email: string;
    reps: ICompanyRep[];
    ref: string;
    role_name?: string;
    role?: string;
    last_login?: string;
    last_viewed?: string;
    default_rep?: ICompanyRep;
    terms_signed?: {
        date: string;
        version: number;
    };
}

export interface IBuyer {
    _id?: string;
    ref: string;
    name: string;
    email: string;
    phone?: string;
    created_on: string;
}

interface ICategory {
    name: string;
    subcategories: string[];
}

export interface IRetailer {
    addresses: IAddress[];
    buyers: IBuyer[];
    brands: string[];
    categories: string[];
    classifications: { key: string[] };
    clientele_desc: string;
    description: string;
    email: string;
    header_image: string;
    images: string[];
    name: string;
    phone: string;
    retail_categories: ICategory[];
    website: string;
}

export interface IContact {
    _id: string;
    name: string;
    buyer?: IUserConnection;
    user?: IUserConnection;
    __sortable_name: string;
    code: string;
    currency_codes: string[];
    discount: number;
    surcharge: number;
    user_connections?: IUserConnection[];
    access_control?: AccessControl;
}

export interface IKeys {
    consumer_key: string;
    consumer_secret_key: string;
}

export interface ICompanyApp {
    application_name: string;
    token: string;
    token_secret: string;
    authorized: boolean;
    verifier?: string;
    _id: string;
}

export interface ICompanyApi extends IKeys {
    tokens: ICompanyApp[];
}

export interface IOption<T = any> {
    name: string;
    value: T;
}

export interface IScopeValues {
    reps: ICompanyRep[];
    roleOptions: Array<IOption<string>>;
    repsOptions: Array<IOption<ICompanyRep>>;
    warehouses?: Array<IOption<string>>;
    currencies?: Array<IOption<string>>;
    groupNames?: Array<IOption<string>>;
    legalFiles?: Array<IOption<string>>;
}
